import React, {
  ReactNode, useEffect, useLayoutEffect, useMemo, useRef, useState,
} from 'react';
import styled from 'styled-components';
import {
  Company, CompanyComparisonData, Row, SharePrice,
} from 'Types/CompaniesTypes';
import {
  boxShadow,
  maxWidth, retina, scrollbarX,
  maxWidth1300, wMBold, wMedium,
  midMobile, maxMobile, maxTablet,
  minWidthApp, primaryColor, primaryFont, primaryHeadingColor,
  secondaryFont, smMobile,
  gilroyAnimationChart,
} from 'Utils/utilsStyle';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import CloseIconFilled from 'Components/company/svgIcons/CloseIconFilled';
import { useDispatch, useSelector } from 'react-redux';
import SelectCompanyModal from 'Components/companyComparison/components/SelectCompanyModal';
import {
  selectisComparisonLoading,
  selectCompanyDetailFlurry, selectCompanyDetailsCall,
  selectedCompareCompaniesIds,
  selectCompareProductAndServices,
  selectCompareSubsidiaries,
} from 'Selector/CompaniesSelector';
import {
  COMPANY_NEWS_ROUTE, COMPANY_OVERVIEW_ROUTE,
  INDUSTRY_NEWS_ROUTE, NO_COMPANY_FOUND, PERSONALITY_INSIGHTS_ROUTE, UP_PRICE,
  translateSkipAreas,
} from 'Utils/Constants';
import NoPersonsFound from 'Components/common/components/NoPersonsFound';
import classNames from 'classnames';
import { Alert } from 'Types/ArticleTypes';
import { Spin } from 'antd';
import { isSalesforceRoute, scrollWithId, valueToObject } from 'Utils/UtilityFunctions';
import { isMappedSubsidiary } from 'Utils/subsidiaryUtils';
import { actions as flurryActions, actions as helperActions } from 'Slice/HelperSlice';
import CompanyCardLarge from '../../Components/common/components/CompanyCardLarge';
import { actions as companiesActions } from '../../Slice/CompaniesSlice';

import SwotCompanyHeading from './SwotCompanyHeading';
import SwotCompanyData from './SwotCompanyData';
import FittedNamesCell, { NameItem } from './FittedNamesCell';
import { useNavigate } from 'react-router-dom';
import GlobalButton from '../../Components/common/components/GlobalButton';
import ExportIcon from '../../Components/common/assets/svgIcons/ExportIcon';

const InnerStyleWrapper = styled.div`
  // custom width apply due to reason
  @media all and (max-width: ${minWidthApp}) { 
    overflow-x: scroll;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    ${scrollbarX}
  }
`;

const InnerTable = styled.div`
 
`;

const StyledWrapper = styled.div`
  box-shadow: ${boxShadow};
  border-radius: 16px;
  position: relative;
  background-color: #fff;
  padding: 20px 50px 20px 50px;
  margin-top: 50px;
  margin-bottom: 100px;

  @media all and (max-width: ${minWidthApp}) {
    padding: 20px;
  }
  @media all and (max-width: ${smMobile}) {
    padding: 10px;
  }
  @media all and (max-width: ${maxTablet}) {
    box-shadow: none;
  }

  &.rowGreaterThen {
    margin-bottom: 300px;
  }
  &.emptyState {
    margin-bottom: 20px;
  }
  .fancy-box {
    margin-bottom: 10px;
    h1 {
      font-family: ${secondaryFont};
      color: ${primaryHeadingColor};
      font-size: 28px;
      margin-bottom: 0;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 19px;
      }
      @media all and (max-width: ${maxMobile}) {
        font-size: 16px;
      }
    }
    .add-company-btn-compare {
      padding: 10px 20px 10px 15px;
    }
    .export-company-comparison {
      .export_btn {
        &:hover {
          border: 1px solid ${primaryColor};
          color: ${primaryColor}; 
          svg {
            path {
              fill: ${primaryColor}; 
            }
          }
        }
        svg {
          margin-right: 10px;
          width: 17px;
          min-width: 17px;
          @media all and (max-width: ${maxWidth}) ,${retina} {
            width: 11px;
            min-width: 11px;
          }
        }
      }
      @media all and (max-width: ${minWidthApp}){ 
        width: 30px;
        margin-right: 15px;
        .export_btn {
          width: 33px;
          height: 32px;
          padding: 10px;
          svg {
            width: 14px;
            min-width: 14px;
          }
        }
      }
    }
  }

  &.companies-length-0 {
    min-height: 500px;
  }

  &.companies-length-1 {
   .table-item {
    flex: 1 1 100%;
   } 
   .swot-sticky {
      .table-item {
        /* border-right: none !important; */
      }
    }
  }

  &.companies-length-2 {
    .table-item {
     flex: 1 1 50%;
    } 
    .table-width-decide {
      @media all and (max-width: ${maxMobile}) {
        min-width: calc(100vw + 200px);
      }
    }
    .isCompanyTableItem {
      .companyName {
        max-width: 400px;
        @media all and (max-width: ${maxWidth1300}) {
          max-width: 250px;
        }
      }
    }
  }
  &.companies-length-3 {
    .table-item {
     flex: 1 1 30%;
    }
    .table-width-decide {
      @media all and (max-width: ${minWidthApp}) {
        min-width: calc(100vw + 300px);
      }
    }
    .companyName {
      max-width: 200px;
      @media all and (max-width: ${maxWidth1300}) {
        max-width: 150px;
      }
    }
  }
  &.companies-length-4 {
    .table-item {
     flex: 1 1 0%;
     padding: 16px 5px;
     @media all and (min-width: ${minWidthApp}) and (max-width: 1220px) {
        min-width: 150px;
     }
    }
    .table-width-decide {
      @media all and (max-width: ${minWidthApp}) {
        min-width: calc(100vw + 400px);
      }
    }
    .isCompanyTableItem {
      .companyName {
       max-width: 200px;
       @media all and (max-width: ${maxWidth1300}) {
         max-width: 150px;
       }
      }
    }
  }
  .spinner-area {
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center; 
    backdrop-filter: blur(10px);
    z-index: 1;
    margin-top: -30px;
    margin-left: -50px;
    box-sizing: border-box;
    .ant-spin {
      margin-top: 300px;
    }
    @media all and (max-width: ${minWidthApp}){
      margin-top: -19px;
      margin-left: -19px;
    }
  }
  .dot-item {
    margin: 0px 4px;
    display: inline-block;
    span {
      margin-right: 5px;
    }
  }
  .first-side {
     width: calc(100% - 200px);
    @media all and (max-width: ${maxTablet}){
      width: calc(100% - 100px)
    }
  }
`;

const TableHeader = styled.div`
  display: flex;
  border: 1px solid #DADADA;
  border-left: none;
  border-radius: 16px 16px 0px 0px;

  
  
  .table-item {
    text-align: center;
    padding: 20px 10px;
    border-left: 1px solid #DADADA;
    position: relative;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-end;

    @media all and (max-width: ${midMobile}) {
      align-items: center;
    }

    .close-icon-area {
      position: absolute;
      right: 0px;
      top: 0px;
      cursor: pointer;
      padding: 10px;
      @media all and (max-width: ${maxTablet}) and (min-width: ${maxMobile}) {
        right: -4px;
        top: -5px;
      }
    }

    &:nth-child(1) {
      text-align: left;
      min-width: 200px;
      border-radius: 16px 0px 0px 0px;
      @media all and (max-width: ${smMobile}) {
        min-width: 170px;
      }
    }

    &:last-child {
      border-radius: 0 16px 0 0;
    }

    @media all and (max-width: ${maxTablet}) {
     padding: 8px;
     min-height: 175px;
    }

    @media all and (max-width: ${maxMobile}) {
     min-height: 140px;
    }

  }
`;

const TableBody = styled.div`
  display: flex;
  border: 1px solid #DADADA;
  border-left: none;
  border-top: none;
  &.body-table {
    &.swot-sticky {
      /* SWOT / pain point bullets read left-aligned from the top, not centered like data cells */
      /* SWOT heading fills its cell so the expand arrow stays pinned to the top-right corner */
      .second-area,
      .sticky-area {
        align-items: stretch;
        justify-content: flex-start;
      }
      &:last-child {
        .second-area {
          border-bottom: 1px solid rgb(66, 75, 80);
        }
      }
      .table-item {
        &:first-child {
          border-bottom: 1px solid rgb(218, 218, 218);
        }
      }
    }
  }
  &:last-child {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    .table-item {
      &:first-child {
        border-bottom-left-radius: 16px;
      }
      &:last-child {
        border-bottom-right-radius: 16px;
      }
    }
  }
  .table-item {
    flex: auto;
    text-align: center;
    padding: 25px 16px;
    border-left: 1px solid #DADADA;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &:nth-child(1) {
      text-align: left;
      align-items: flex-start;
      min-width: 200px;
      @media all and (max-width: ${smMobile}) {
        min-width: 170px;
      }
    }

    @media all and (max-width: ${maxTablet}) {
     padding: 25px 8px;
    }

    .small-text{
      font-size: 10px;
      @media all and (max-width: ${smMobile}) {
       font-size: 8px;
      }
    }
    .table-item-data {
      &.linkText {
        color: ${primaryColor};
        cursor: pointer;
      }
      word-break: break-all;
      font-family: ${primaryFont};
      font-size: 14px;
      font-weight: ${wMedium};
      color: ${primaryHeadingColor};
      /* width: 80%; */
      word-break: break-word;
      max-width: 100%;
      @media all and (max-width: ${maxMobile}) {
       line-height: 16px;
      }
      @media all and (max-width: ${smMobile}) {
       line-height: 12px;
       font-size: 10px;
      }
    }
  }
`;

const Heading = styled.span`
&.animation-div {
  justify-content: center;
  align-items: center;
  padding-top: 50px;
  background: #E8F8EC;
  @media all and (max-width: ${maxWidth1300}) {
    padding-top: 60px;
  }
}
  color: ${primaryHeadingColor};
  font-family: ${secondaryFont};
  letter-spacing: -0.45px;
  font-size: 16px;
  line-height: 20px;
  font-weight: ${wMBold};
  width: 160px;
  min-width: 160px;
  max-width: 160px;
  display: grid;
  position: relative;
  z-index: 0;
  @media all and (max-width: ${maxTablet}) {
    font-size: 12px;
    line-height: 16px;
    min-width: 120px;
    max-width: 120px;
    width: 120px;
  }

  .heading-item {
    z-index: 1;
  }

  .animation-item {
    .graph-animation {
      position: absolute;
      width: 150px;
      height: 150px;
      top: 35%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 0;
      @media all and (max-width: ${maxWidth}),${retina} {
        transform: translate(-50%, -50%) scale(0.87);
      }
      @media all and (max-width: ${maxWidth1300}) {
        transform: translate(-50%, -50%) scale(0.8);
      }
      @media all and (max-width: ${maxTablet}) {
        transform: translate(-50%, -50%) scale(0.8);
      }
      @media all and (max-width: ${maxMobile}) {
        transform: translate(-50%, -50%) scale(0.62);
      }
      @media all and (max-width: ${smMobile}) {
        transform: translate(-50%, -50%) scale(0.63);
      }
    }
  }
  .add-company-button-wrapper {
    position: absolute;
    bottom: 40px;
    width: 100%;
    padding: 0 12px;
    @media all and (max-width: ${maxMobile}) {
      bottom: 28px;
    }
  }
  .companies-count-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 10px 12px;
    gap: 5px;

    .companies-count-text {
      font-family: ${primaryFont};
      font-size: 12px;
      font-weight: ${wMedium};
      color: #979797;
      text-align: center;
      @media all and (max-width: ${maxTablet}) {
        font-size: 12px;
      }
    }
    .companies-count {
      span {
        font-size: 12px;
        font-weight: ${wMBold};
        color: ${primaryHeadingColor};
        text-align: center;
        @media all and (max-width: ${maxTablet}) {
          font-size: 11px;
        }
      }
    }
  }

    
  }
`;

const Dot = styled.span`
  height: 8px;
  width: 8px;
  margin-left: 6px;
  margin-right: 3px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  display: inline-block;
`;

const CountDiv = styled.div`
  display: flex; 
  align-items: center;
  justify-content: center;
  font-size: 16px;
  height: 38px;
  border-radius: 8px;
  width: 38px;
  background-color: #DEF6E6;
  color: ${primaryColor};
  z-index: 1;
  @media all and (max-width: ${maxTablet}) {
    font-size: 14px;
    height: 32px;
  }
`;

const Arrow = styled.span`
  color: ${(props) => props.color};
`;

const PRODUCT_AND_SERVICES_ROW = 'productsAndServices';
const SUBSIDIARIES_ROW = 'companySubsidiaries';

type Props = {
  companiesData: CompanyComparisonData[];
  comparisonRows: Row[];
  savedUrlV2: string;
};

const CompanyComparisonTable = function CompanyComparisonTable(props: Props) {
  const {
    companiesData,
    comparisonRows,
    savedUrlV2,
  } = props;
  const [showSWOT, setShowSWOT] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isComparisonLoading = useSelector(selectisComparisonLoading);
  const selectedCompareCompanies = useSelector(selectedCompareCompaniesIds);
  const formatSharePrice = (sharePrice: SharePrice) => `${sharePrice.currency}${sharePrice.value}`;
  const [expandSwot, setExpandSwot] = useState('');
  const flurryObject = useSelector(selectCompanyDetailFlurry);
  const isCalled = useSelector(selectCompanyDetailsCall);
  const compareProductAndServices = useSelector(selectCompareProductAndServices);
  const compareSubsidiaries = useSelector(selectCompareSubsidiaries);
  const pendingPsRef = useRef<Set<number>>(new Set());
  const pendingSubsidiariesRef = useRef<Set<number>>(new Set());

  // Fetch P&S and subsidiaries only for companies whose data is not in the store yet
  useEffect(() => {
    companiesData.forEach(({ companyId }) => {
      if (!companyId) return;
      if (compareProductAndServices[companyId]) {
        pendingPsRef.current.delete(companyId);
      } else if (!pendingPsRef.current.has(companyId)) {
        pendingPsRef.current.add(companyId);
        dispatch(companiesActions.getCompareProductAndServices({ companyId }));
      }
      if (compareSubsidiaries[companyId]) {
        pendingSubsidiariesRef.current.delete(companyId);
      } else if (!pendingSubsidiariesRef.current.has(companyId)) {
        pendingSubsidiariesRef.current.add(companyId);
        dispatch(companiesActions.getCompareSubsidiaries({ companyId, page: 1 }));
      }
    });
  }, [companiesData, compareProductAndServices, compareSubsidiaries]);

  // Stable name arrays per company, so cells only re-measure when their data changes
  const productAndServicesNames = useMemo(() => {
    const result: Record<number, NameItem[]> = {};
    Object.entries(compareProductAndServices).forEach(([id, data]) => {
      result[Number(id)] = [...(data.products || []), ...(data.services || [])]
        .filter((item) => item.name)
        .map((item) => ({ name: item.name }));
    });
    return result;
  }, [compareProductAndServices]);

  const subsidiaryNames = useMemo(() => {
    const result: Record<number, NameItem[]> = {};
    Object.entries(compareSubsidiaries).forEach(([id, data]) => {
      // Mapped subsidiaries carry their id so the name links to their company page
      result[Number(id)] = data.companySubsidiaries
        .filter((company) => company.companyName)
        .map((company) => ({
          name: company.companyName,
          id: isMappedSubsidiary(company) ? company.companyId : undefined,
        }));
    });
    return result;
  }, [compareSubsidiaries]);

  const allRows = useMemo(() => {
    const rows = [...(comparisonRows || [])];
    const companyIds = companiesData.map((company) => company.companyId);
    if (companyIds.some((id) => productAndServicesNames[id]?.length)) {
      rows.push({ title: 'Product and Services', type: PRODUCT_AND_SERVICES_ROW });
    }
    if (companyIds.some((id) => subsidiaryNames[id]?.length)) {
      rows.push({ title: 'Subsidiaries', type: SUBSIDIARIES_ROW });
    }
    return rows;
  }, [comparisonRows, companiesData, productAndServicesNames, subsidiaryNames]);

  const handleExport = () => {
    const exportData = {
      companyIds: selectedCompareCompanies?.join(','),
    };
    dispatch(companiesActions.compareCompaniesExport(exportData));
  };

  const renderNamesCell = (
    items: NameItem[] | undefined,
    hasMoreOnServer = false,
    onNameClick?: (id: number) => void,
  ) => {
    if (!items) return <span className="table-item-data"><Spin size="small" /></span>;
    return (
      <FittedNamesCell
        items={items}
        onNameClick={onNameClick}
        hasMoreOnServer={hasMoreOnServer}
        onMoreClick={handleExport}
        disabled={isComparisonLoading}
        className="table-item-data"
      />
    );
  };

  const checkCompaniesSWOT = () => {
    companiesData.forEach((companies) => {
      companies.companySwot?.swotAnalysis?.forEach((swot) => {
        if (swot.data.length) {
          setShowSWOT(true);
        }
      });
    });
  };

  useEffect(() => {
    if (companiesData.length) {
      checkCompaniesSWOT();
    }
  }, [companiesData]);
  const scrollToSectionOnExpand = (id: string) => {
    const element: HTMLElement | null = document.getElementById(id);
    if (element) {
      setTimeout(() => {
        scrollWithId(element, 60);
      }, 0.5);
    }
  };
  const expandSwotToggle = (heading: string) => {
    if (heading !== expandSwot) {
      setExpandSwot(heading);
      scrollToSectionOnExpand(heading);
    } else setExpandSwot('');
  };
  const handleClose = (companyId: number) => {
    setShowSWOT(false);
    dispatch(companiesActions.removeComparisonCompany(companyId));
    dispatch(companiesActions.removeCompareCompaniesIds(companyId));
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('remove_compare_comapny', 0, {
        ...flurryObject,
        ...isCalled && { isCalled },
        companyId,
      }),
    ));
  };

  const handlePersonClick = (id: number) => {
    if (id > 0) {
      if (isSalesforceRoute()) {
        navigate(`${PERSONALITY_INSIGHTS_ROUTE}${id}`);
      } else {
        window.open(`${PERSONALITY_INSIGHTS_ROUTE}${id}`);
      }
    }
  };

  const handleCompanyClick = (id: number) => {
    if (id > 0) {
      if (isSalesforceRoute()) {
        navigate(`${COMPANY_OVERVIEW_ROUTE}${id}`);
      } else {
        window.open(`${COMPANY_OVERVIEW_ROUTE}${id}`);
      }
    }
  };

  const handleIndustryClick = (id: number) => {
    if (id > 0) {
      if (isSalesforceRoute()) {
        navigate(`${INDUSTRY_NEWS_ROUTE}${id}`);
      } else {
        window.open(`${INDUSTRY_NEWS_ROUTE}${id}`);
      }
    }
  };

  const handleAlertClick = (id: number, alerts: Alert[]) => {
    if (id > 0 && alerts.length) {
      const alertIds = alerts.slice(0, 3).map((alert) => alert.alertId).join(',');
      if (isSalesforceRoute()) {
        navigate(`${COMPANY_NEWS_ROUTE}${id}&filterId=${alertIds}`);
      } else {
        window.open(`${COMPANY_NEWS_ROUTE}${id}&filterId=${alertIds}`);
      }
    }
  };
  useLayoutEffect(() => {
    if (selectedCompareCompanies?.length) {
      const exportData = {
        companyIds: selectedCompareCompanies?.join(','),
      };
      const compareData = {
        companyIds: selectedCompareCompanies?.slice(0, 4)?.join(','),
      };
      if (selectedCompareCompanies?.length >= 5) {
        dispatch(companiesActions.compareCompaniesExport(exportData));
        dispatch(helperActions.setNotification({
          message: 'You have selected more than four companies. Comparison data will be provided in an Excel file.',
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: true,
        }));
      }
      dispatch(companiesActions.compareCompanies(compareData));
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('add_compare_company', 0, {
          ...flurryObject,
          ...isCalled && { isCalled },
          companyIds: exportData.companyIds,
        }),
      ));
    }
    return () => {
      dispatch(companiesActions.resetCompareCompaniesIds());
    };
  }, []);

  const handleWebClick = (link: string) => {
    if (link?.length) window.open(link.slice(0, 4) === 'http' ? link : `https://${link}`);
  };

  return (
    <StyledWrapper className={classNames(`companies-length-${companiesData.length}`, {
      rowGreaterThen: allRows.length <= 7,
      emptyState: companiesData.length === 0 && !isComparisonLoading,
    })}
    >
      {isComparisonLoading
        && <span className="spinner-area skeleton-box-transparent"><Spin /></span>}

      <div className="fancy-box d-flex justify-content-end align-items-center">
        {companiesData.length > 1 && (
          <div className="export-company-comparison">
            <GlobalButton
              title="Export"
              textColor="#7E7E7E"
              bgColor="#fff"
              outlineColor="#DADADA"
              innerSpace="9px 20px 9px 20px"
              PaddingSm="6px 15px"
              LeftSpace="7px"
              IconLeft={<ExportIcon />}
              buttonClassName="share-button mr-24 export_btn"
              rightSeparatorClassName="right-separator-class"
              onButtonClick={handleExport}
              disabled={isComparisonLoading}
            />
          </div>
        )}
        {companiesData.length === 0 && !isComparisonLoading
          ? <SelectCompanyModal savedUrlV2={savedUrlV2} inCompanyCompare /> : null}
      </div>
      <InnerStyleWrapper>
        <InnerTable className="table-width-decide">
          {(companiesData.length === 0
            && !isComparisonLoading && selectedCompareCompanies.length === 0)
            ? <NoPersonsFound title={NO_COMPANY_FOUND} /> : (
              <>
                <TableHeader className="header-table">
                  <Heading className="table-item animation-div">
                    <div className="heading-item">
                      <div className="animation-item">
                        <img src={gilroyAnimationChart} alt="graph-animation" className="graph-animation" />
                      </div>
                    </div>
                    <div className="add-company-button-wrapper">
                      <SelectCompanyModal stickyTableView inCompanyCompare />
                    </div>
                    {companiesData.length > 0 && (
                      <div className="companies-count-wrapper">
                        <div className="companies-count-text">
                          Add up to 4 Companies
                        </div>
                        <div className="companies-count">
                          <span>({companiesData.length}/4)</span>
                        </div>
                      </div>
                    )}
                  </Heading>
                  {companiesData.map((company) => (
                    <span className="table-item">
                      <span
                        className="close-icon-area"
                        onClick={() => handleClose(company.companyId)}
                        onKeyPress={() => handleClose(company.companyId)}
                        role="button"
                        tabIndex={0}
                      >
                        <CloseIconFilled />
                      </span>
                      <CompanyCardLarge
                        companyData={company as Company}
                        key={company.companyId}
                        currency={company.sharePriceObject.currency}
                        isCompanyCompare
                        isTableCompanyCompare
                      />
                    </span>
                  ))}
                </TableHeader>

                {allRows.map((row) => (
                  <TableBody className="body-table">
                    <Heading className="table-item">
                      {row.title}
                      {row.type === 'companyPulse' ? <div className="small-text">(1 Month)</div> : null}
                    </Heading>
                    {
                      companiesData.map((company: CompanyComparisonData) => {
                        const {
                          companyCeo, sharePriceObject,
                          companyAlerts, companyExecutives, companyCompetitor, companyIndustry,
                          companyDomain, companyWebsite,
                        } = company;
                        return (
                          <span className="table-item">
                            {row.type !== 'companyPulse' && row.type !== 'sharePriceObject'
                              && row.type !== 'companyWebsite' && row.type !== 'companyCeo' && row.type !== 'companyExecutives' && row.type !== 'companyIndustry' && row.type !== 'companyCompetitor'
                              && row.type !== PRODUCT_AND_SERVICES_ROW
                              && row.type !== SUBSIDIARIES_ROW
                              && (
                                <span className="table-item-data text-truncate-three-line">
                                  {company[row.type as keyof typeof company] ? company[row.type as keyof typeof company] as ReactNode : 'N/A'}
                                </span>
                              )}
                            {row.type === PRODUCT_AND_SERVICES_ROW
                              && renderNamesCell(productAndServicesNames[company.companyId])}
                            {row.type === SUBSIDIARIES_ROW
                              && renderNamesCell(
                                subsidiaryNames[company.companyId],
                                (compareSubsidiaries[company.companyId]?.totalCount ?? 0)
                                > (subsidiaryNames[company.companyId]?.length ?? 0),
                                handleCompanyClick,
                              )}
                            {row.type === 'companyPulse' && (
                              <span className={classNames('table-item-data text-truncate-three-line', { linkText: companyAlerts.length })}>
                                {companyAlerts?.length
                                  ? (
                                    <span
                                      role="button"
                                      tabIndex={0}
                                      onClick={() => {
                                        handleAlertClick(company.companyId, companyAlerts);
                                      }}
                                      onKeyPress={() => {
                                        handleAlertClick(company.companyId, companyAlerts);
                                      }}
                                    >
                                      {
                                        companyAlerts.slice(0, 3).map((alert) => (
                                          <span className="dot-item">
                                            <Dot color={alert.color} />
                                            {alert.alert}
                                          </span>
                                        ))
                                      }
                                    </span>
                                  ) : 'N/A'}
                              </span>
                            )}
                            {
                              row.type === 'companyExecutives' && (
                                <span className={classNames('table-item-data text-truncate-three-line', { linkText: companyExecutives && companyExecutives.length })}>
                                  {companyExecutives && companyExecutives.length
                                    ? companyExecutives.slice(0, 3).map((person, index) => (
                                      <span
                                        onClick={() => {
                                          handlePersonClick(person.personId);
                                        }}
                                        onKeyPress={() => {
                                          handlePersonClick(person.personId);
                                        }}
                                        role="button"
                                        aria-label={person.personName?.length ? person.personName : 'N/A'}
                                        tabIndex={0}
                                      >
                                        {person.personName}
                                        {index !== companyExecutives.slice(0, 3).length - 1 && ', '}
                                      </span>
                                    )) : 'N/A'}
                                </span>
                              )
                            }
                            {
                              row.type === 'companyIndustry' && (
                                <span
                                  className={classNames('table-item-data text-truncate-three-line', { linkText: companyIndustry.name?.length })}
                                  onClick={() => {
                                    handleIndustryClick(companyIndustry.id);
                                  }}
                                  onKeyPress={() => {
                                    handleIndustryClick(companyIndustry.id);
                                  }}
                                  role="button"
                                  aria-label={companyIndustry?.name?.length ? companyIndustry?.name : 'N/A'}
                                  tabIndex={0}
                                >
                                  {companyIndustry?.name?.length ? companyIndustry.name : 'N/A'}
                                </span>
                              )
                            }
                            {
                              row.type === 'companyCompetitor' && (
                                <span
                                  className={classNames('table-item-data text-truncate-three-line', { linkText: companyCompetitor.companyName?.length })}
                                  onClick={() => {
                                    handleCompanyClick(companyCompetitor.companyId);
                                  }}
                                  onKeyPress={() => {
                                    handleCompanyClick(companyCompetitor.companyId);
                                  }}
                                  role="button"
                                  aria-label={companyCompetitor?.companyName?.length ? companyCompetitor.companyName : 'N/A'}
                                  tabIndex={0}
                                >
                                  {companyCompetitor.companyName?.length ? companyCompetitor.companyName : 'N/A'}
                                </span>
                              )
                            }
                            {
                              row.type === 'companyWebsite' && (
                                <span
                                  className={classNames(`table-item-data text-truncate-three-line ${translateSkipAreas}`, { linkText: companyDomain?.length })}
                                  onClick={() => {
                                    handleWebClick(companyWebsite?.length
                                      ? companyWebsite : '');
                                  }}
                                  onKeyPress={() => {
                                    handleWebClick(companyWebsite?.length
                                      ? companyWebsite : '');
                                  }}
                                  role="button"
                                  aria-label={companyDomain?.length ? companyDomain : 'N/A'}
                                  tabIndex={0}
                                >
                                  {companyDomain?.length ? companyDomain : 'N/A'}
                                </span>
                              )
                            }
                            {
                              row.type === 'companyCeo' && (
                                <span
                                  className={classNames('table-item-data text-truncate-three-line', { linkText: companyCeo.personName?.length })}
                                  onClick={() => {
                                    handlePersonClick(companyCeo.personId);
                                  }}
                                  onKeyPress={() => {
                                    handlePersonClick(companyCeo.personId);
                                  }}
                                  role="button"
                                  aria-label={companyCeo.personName?.length ? companyCeo.personName : 'N/A'}
                                  tabIndex={0}
                                >
                                  {companyCeo.personName?.length ? companyCeo.personName : 'N/A'}
                                </span>
                              )
                            }
                            {
                              row.type === 'sharePriceObject' && (
                                <span className="table-item-data text-truncate-three-line">
                                  {sharePriceObject
                                    ? (
                                      <>
                                        {`${formatSharePrice(sharePriceObject)}`}
                                        <span className="sign">
                                          <Arrow color={sharePriceObject.color}>
                                            {sharePriceObject.sign === UP_PRICE
                                              ? <CaretUpOutlined /> : <CaretDownOutlined />}
                                          </Arrow>
                                        </span>
                                      </>
                                    )
                                    : 'N/A'}
                                </span>
                              )
                            }
                          </span>
                        );
                      })
                    }
                  </TableBody>
                ))}
                {showSWOT ? (

                  companiesData.length
                  && companiesData[0]?.companySwot
                  && companiesData[0]?.companySwot?.swotAnalysis.length
                  && companiesData[0]?.companySwot?.swotAnalysis.map((swot, i) => (
                    <TableBody
                      className={classNames(
                        'body-table swot-sticky',
                      )}
                      id={swot.heading}
                    >
                      <SwotCompanyHeading
                        expandSwot={expandSwotToggle}
                        expand={expandSwot}
                        heading={swot?.heading}
                        color={swot?.color}
                      />
                      {companiesData.map((company) => (
                        <SwotCompanyData
                          expandSwot={expandSwot === swot?.heading}
                          color={swot?.color}
                          data={company?.companySwot?.swotAnalysis[i]?.data}
                        />
                      ))}
                    </TableBody>
                  ))

                ) : null}

              </>
            )}
        </InnerTable>
      </InnerStyleWrapper>
    </StyledWrapper >
  );
};

export default CompanyComparisonTable;
